module.exports = __webpack_public_path__ + "static/media/Icond-6.ccb2b860.svg";